import React from "react";
import AppleLocalNav from "../../AppleLocalNav";
export default function FinancialNav(){return <AppleLocalNav title="Financials" overview="/financials" pages={[{label:"Publications",to:"/publications"}]} />;}
